import logger from "../utils/logger";

export async function GetClients() {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: "SELECT cid as id, MAX(name) as name, MAX(vendor) as vendor, MAX(payment_terms) as payment_terms FROM project_master GROUP BY cid ORDER BY name ASC",
                params: ["project_master"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("GetClients failed", {}, error);
        return [];
    }
}

export async function GetVendors() {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: "SELECT DISTINCT vendor FROM project_master WHERE vendor IS NOT NULL AND vendor != '' ORDER BY vendor ASC",
                params: ["project_master"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("GetVendors failed", {}, error);
        return [];
    }
}

export async function getProjectMaster() {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/api/project_master?_size=500");
        return await response.json();
    } catch (error) {
        logger.error("getProjectMaster failed", {}, error);
        return [];
    }
}

export async function GetProjectByClient(id: any) {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/api/project_master?_where=(cid,eq," + id + ")");
        return await response.json();
    } catch (error) {
        logger.error("GetProjectByClient failed", { id }, error);
        return [];
    }
}

export async function AddClient(data) {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const rawResponse = await fetch(apiUrl + "/api/client_master", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        if (!rawResponse.ok) {
            throw new Error(`HTTP error! status: ${rawResponse.status}`);
        }
        const content = await rawResponse.json();
        if (content?.insertId) {
            const createdResponse = await fetch(apiUrl + "/api/client_master/" + content.insertId);
            if (createdResponse.ok) {
                const createdRecord = await createdResponse.json();
                console.log("AddClient created record:", createdRecord);
                return createdRecord;
            }
        }

        console.log("AddClient response:", content);

        return content;
    } catch (error) {
        logger.error("AddClient failed", { data }, error);
        return null;
    }
}
export async function AddProjectMaster(data) {
    try {
        const rawResponse = await fetch(process.env.REACT_APP_API_URL + "/api/project_master", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        const content = await rawResponse.json();
        console.log("AddProjectMaster response:", content);

        return content;
    } catch (error) {
        logger.error("AddProjectMaster failed", { data }, error);
        return [];
    }
}

export async function UpdateProject(data) {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const rawResponse = await fetch(apiUrl + "/api/project", {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        if (!rawResponse.ok) {
            throw new Error(`HTTP error! status: ${rawResponse.status}`);
        }
        const content = await rawResponse.json();
        console.log("UpdateProject response:", content);
        return content;
    } catch (error) {
        logger.error("UpdateProject failed", { data }, error);
        return null;
    }
}

export async function GetProjects() {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/api/project_master?_size=500");
        return await response.json();
    } catch (error) {
        logger.error("GetProjects failed", {}, error);
        return [];
    }
}

export async function GetProjectByUUID(uuid) {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/api/project_master?_where=(uuid,eq," + uuid + ")");
        return await response.json();
    } catch (error) {
        logger.error("GetProjectByUUID failed", { uuid }, error);
        return [];
    }
}

export async function GetAllProjectsSorted() {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: "select * from project_master ORDER BY name ASC",
                params: ["project_master"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("GetAllProjectsSorted failed", {}, error);
        return [];
    }
}

export async function GetAssignedProject(uuid) {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: "SELECT p.uuid, p.pid, pm.name AS p_name, p.rate, p.over_time, p.active, p.start_dt, p.end_dt, p.pay_type, p.billing_period, p.fixed_payment, p.ikat_rate, p.rt_rate, p.commercial_partner, p.ikat_deduction_type, p.ikat_deduction_value, p.rt_deduction_type, p.rt_deduction_value, p.insurance_fee, p.vmo, p.pay_rate, p.notes FROM project p LEFT JOIN project_master pm ON p.pid = pm.pid WHERE p.uuid = '" + uuid + "' AND p.active = true ORDER BY pm.name ASC",
                params: ["project"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("GetAssignedProject failed", { uuid }, error);
        return [];
    }
}

export async function AddProjectAssignment(data) {
    try {
        const rawResponse = await fetch(process.env.REACT_APP_API_URL + "/api/project", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        if (!rawResponse.ok) {
            throw new Error(`HTTP error! status: ${rawResponse.status}`);
        }
        const content = await rawResponse.json();
        console.log("AddProjectAssignment response:", content);
        return content;
    } catch (error) {
        logger.error("AddProjectAssignment failed", { data }, error);
        return null;
    }
}

export async function UpdateProjectAssignment(data) {
    try {
        const rawResponse = await fetch(process.env.REACT_APP_API_URL + "/api/project", {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        if (!rawResponse.ok) {
            throw new Error(`HTTP error! status: ${rawResponse.status}`);
        }
        const content = await rawResponse.json();
        console.log("UpdateProjectAssignment response:", content);
        return content;
    } catch (error) {
        logger.error("UpdateProjectAssignment failed", { data }, error);
        return null;
    }
}

export async function DeleteProjectAssignment(uuid, pid) {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/api/project?_where=(uuid,eq," + uuid + ")~and(pid,eq," + pid + ")", {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
        });
        return await response.json();
    } catch (error) {
        logger.error("DeleteProjectAssignment failed", { uuid, pid }, error);
        return null;
    }
}

export async function UpdateProjectMaster(data) {
    try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const rawResponse = await fetch(apiUrl + "/api/project_master", {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        if (!rawResponse.ok) {
            throw new Error(`HTTP error! status: ${rawResponse.status}`);
        }
        const content = await rawResponse.json();
        console.log("UpdateProjectMaster response:", content);
        return content;
    } catch (error) {
        logger.error("UpdateProjectMaster failed", { data }, error);
        return null;
    }
}

export async function getAllProjects() {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: "select *,cm.name as clientName from client_master as cm right join project_master as pm on cm.id= pm.cid",
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("getAllProjects failed", {}, error);
        return [];
    }
}

export async function getAllProjectsByUuid(uuid) {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: "select * from project_master as pm left join project as p on pm.pid = p.pid where p.uuid = '" + uuid + "' order by p.start_dt desc, p.active desc",
                params: ["payroll"],
            },
        ),
        });

        return await response.json();
    } catch (error) {
        logger.error("getAllProjectsByUuid failed", { uuid }, error);
        return [];
    }
}

export async function updateProjectPaymentTerms(pid: string, paymentTerms: string) {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: `UPDATE project_master SET payment_terms = '${paymentTerms}' WHERE pid = '${pid}'`,
                params: ["project_master"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("updateProjectPaymentTerms failed", { pid, paymentTerms }, error);
        return [];
    }
}

export async function AddProject(data) {
    try {
        delete data["cid"];
        delete data["name"];
        delete data["payment_terms"];
        delete data["vendor"];
        delete data["pref_vendor"];

        const rawResponse = await fetch(process.env.REACT_APP_API_URL + "/api/project", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        const content = await rawResponse.json();
        return content;
    } catch (error) {
        logger.error("AddProject failed", { data }, error);
        return [];
    }
}

export async function updateProject(data: any) {
    try {
        // Keeps a cleared rate as a real SQL NULL instead of the string 'null'.
        const sqlNullable = (v: any) => (v === null || v === undefined || v === "" ? "NULL" : `'${v}'`);
        const _q = `UPDATE project SET 
            rate = '${data.rate}',
            over_time = ${sqlNullable(data.over_time)},
            over_time_rate = ${sqlNullable(data.over_time_rate)},
            billing_period = '${data.billing_period}',
            ikat_rate = ${sqlNullable(data.ikat_rate)},
            rt_rate = ${sqlNullable(data.rt_rate)},
            commercial_partner = ${sqlNullable(data.commercial_partner)},
            ikat_deduction_type = ${sqlNullable(data.ikat_deduction_type)},
            ikat_deduction_value = ${sqlNullable(data.ikat_deduction_value)},
            rt_deduction_type = ${sqlNullable(data.rt_deduction_type)},
            rt_deduction_value = ${sqlNullable(data.rt_deduction_value)},
            start_dt = '${data.start_dt}',
            end_dt = '${data.end_dt}',
            active = ${data.active}
            WHERE id = '${data.id}' AND uuid = '${data.uuid}' AND pid = '${data.pid}'`;
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["project"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("updateProject failed", { data }, error);
        return [];
    }
}

export async function deleteProject(params: { uuid: string; pid: string; id: string }) {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: `DELETE FROM project WHERE uuid = '${params.uuid}' AND pid = '${params.pid}' AND id = '${params.id}'`,
                params: ["project"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("deleteProject failed", { params }, error);
        return [];
    }
}
